/**
 * @preserve
 * Licenses of bundled dependencies can be found in dependencies-licenses.txt
 */
var getRandomId=function(){return Math.random().toString(36).substr(2,9)};export{getRandomId as g};
//# sourceMappingURL=get-random-id-d144894b.js.map